import { History }              from 'history';
import { RouteComponentProps }  from 'react-router';
import { CustomFieldsState }    from '../../reduxTypes';
import {
    Recipient,
    UserSession,
    UserLanguagesType,
}                               from '../../types';
import { MessageTemplateInput } from './MessageTemplatesQuery';
import { QueryResult }          from 'react-apollo';

export enum ViewContextTypes {
    MESSAGES_INPUT = 'messagesInput',
    CHAT_STARTERS  = 'chatStarters',
    DEFAULT        = 'default'
}

export type ViewContextType = ViewContextTypes.MESSAGES_INPUT | ViewContextTypes.CHAT_STARTERS | ViewContextTypes.DEFAULT;

export interface MessageTemplateField {
    name: string;
    specialValidations?: string;
    defaultValue: string;
}

interface MessageTemplateContent {
    message: string;
    fields: MessageTemplateField[];
}

interface MessageTemplateHeaders {
    summary: string;
}

export interface MessageTemplate {
    id: string;
    name: string;
    dealerId: number;
    carrierId: number;
    callListId: number;
    language: UserLanguagesType;
    priority: number;
    metadata: MessageTemplateHeaders;
    template: MessageTemplateContent;
}

export type MessageTemplatesList = MessageTemplate[];

export interface MessageTemplatesPagination {
    size: number;
    totalElements: number;
    totalPages: number;
    current: number; // alias to number node in original payload, see graphql query
}

export interface MessageTemplatesVariables {
    criteria: MessageTemplateInput;
}

export interface MessageTemplatesPayload {
    messageTemplates: MessageTemplates
}

export interface MessageTemplates {
    templates: MessageTemplatesList;
    pageInfo: MessageTemplatesPagination;
}

export interface MessageTemplatesContainerProps extends RouteComponentProps<{ conversationId?: string }>, QueryResult<MessageTemplatesPayload, MessageTemplatesVariables> {
    activeMessageTemplate?: string;
    conversationId: number;
    customFields?: CustomFieldsState;
    history: History;
    initializeTemplates?: (flag: boolean) => void;
    itemsPerPage?: number;
    loadMoreData?: () => void;
    loadNextPage?: () => void;
    loadPrevPage?: () => void;
    mapCustomFields?: (messageTemplates: MessageTemplatesList) => void;
    onDesktop: boolean;
    recipient: Recipient;
    selectMessageTemplate?: (template_id: string) => void;
    sendMessage?: (conversationId: number, messageBody: string, templateId?: string) => void;
    session?: UserSession;
    setInputView?: (type: ViewContextType) => void;
    templatesInitialized?: boolean;
    viewContext?: ViewContextType;
    setHaveMessageTemplates: (flag: boolean) => void;
    customFieldsLoaded?: boolean;
    showCards?: boolean;
    setShowCards?: (showCards: boolean) => void;
}



// WEBPACK FOOTER //
// ./src/sections/MessageTemplatesList/MessageTemplatesListTypes.ts